import React from 'react';
import { BulkRiderUpload } from '../components/rider/BulkRiderUpload';

const BulkRiderImport: React.FC = () => {
  return <BulkRiderUpload />;
};

export default BulkRiderImport;
